import app from "./app";
import auth from "./auth";
import cart from "./cart";
import blog from "./blog";
import blogCategory from "./blogCategory";
import faq from "./faq";
import faqCategory from "./faqCategory";
import reports from "./reports";

// Export all modules
export default {
  app,
  auth,
  cart,
  BLOG_: blog,
  BLOG_CATEGORY_: blogCategory,
  FAQ_: faq,
  FAQ_CATEGORY_: faqCategory,
  reports,
};
